<template>
<modal v-model="modalTurn" dir="right" :modalClass="['fill', 'lg right h100']" :title="modalTurn ? `Turno de ${modalTurn.name}` : ''" hideActions>
    <i v-if="modalTurn && (Auth.role.indexOf('admin') > -1 || modalTurn.ended_at)" class="options icon-dots-vertical" slot="options" @click="Options([
        {text: 'Imprimir Inventario', function: () => {PrintInventory()}, if: !!Local.modules.module_service && modalTurn.module_inventory && (showInventory || modalTurn.ended_at) && modalTurn.role !== 'delivery', icon: 'inventory-print'},
        {text: 'Imprimir Resumen', function: () => {Print()}, if: !!Local.modules.module_service, icon: 'printing'},
        {text: 'Descargar Reporte', function: () => {Export()}, icon: 'download'}
    ])"></i>
    <tabs :tabs="tabs" v-if="Local && tabs && modalTurn" :keyByTab="true" @OnTabHistorial="!modalTurn.history.length ? LoadTurnHistory() : null">

        <!-- vista antigua -->
        <div slot="Resumen" v-if="modalTurn && oldView" class="pa20 copyable">
            <div  v-if="modalTurn.ended_at || showSummary">
                
                <table class="summary">
                    <tr><th>Inicio</th><th>Fin</th></tr>
                    <tr><td>{{Util.Date(modalTurn.started_at, 'HH:mm DD/MM/YYYY')}}</td><td>{{modalTurn.ended_at ? Util.Date(modalTurn.ended_at, 'HH:mm DD/MM/YYYY') : 'Activo'}}</td></tr>
                </table>

                <table class="summary mt10" v-if="modalTurn.role !== 'delivery'">
                    <tr>
                        <th v-if="cashierTurn">Efectivo Inicial</th>
                        <th>Ingresos</th>
                        <th v-if="cashierTurn">Egresos</th>
                        <th v-if="cashierTurn">Balance</th>
                    </tr>
                    <tr>
                        <td v-if="cashierTurn">{{Util.Price(modalTurn.initial_cash)}}</td>
                        <td>{{Util.Price(modalTurn.total_income)}}</td>
                        <td v-if="cashierTurn">{{Util.Price(modalTurn.total_expense)}}</td>
                        <td v-if="cashierTurn">{{Util.Price(modalTurn.total_income - modalTurn.total_expense)}}</td>
                    </tr>
                </table>

                <table class="summary mt10" v-if="modalTurn.role !== 'delivery' && modalTurn.current_pending_payments.total > 0">
                    <tr>
                        <th v-if="cashierTurn">Pagos Pendientes</th>
                        <th v-if="cashierTurn">Transacciones</th>
                        <th v-if="cashierTurn">Total</th>
                    </tr>
                    <tr v-for="method in modalTurn.current_pending_payments.methods" :key="'pp_'+method.method">
                        <td v-if="cashierTurn">{{method.method}}</td>
                        <td v-if="cashierTurn">{{Util.Number(method.transactions)}}</td>
                        <td v-if="cashierTurn">{{Util.Price(method.total)}}</td>
                    </tr>
                    <tr class="bold">
                        <td v-if="cashierTurn">Total</td>
                        <td v-if="cashierTurn">{{Util.Number(modalTurn.current_pending_payments.transactions)}}</td>
                        <td v-if="cashierTurn">{{Util.Price(modalTurn.current_pending_payments.total)}}</td>
                    </tr>
                </table>

            </div>

            <div v-if="modalTurn.comments.length && (showComments || modalTurn.ended_at)">

                <div class="f18 mb20 mt20">Notas y comentarios adicionales</div>

                <table class="summary">
                    <tr><th>Fecha</th><th>Mensaje</th></tr>
                    <tr v-for="(comment, index) in modalTurn.comments" :key="`comment${index}`"><td style="white-space: pre; padding-right: 5px">{{Util.Date(comment.timestamp, 'HH:mm DD/MM/YY')}}</td><td style="white-space: break-spaces; width: 82%;">{{comment.message}}</td></tr>
                </table>
            </div>

            <div class="" v-if="showMethods || modalTurn.ended_at">

                <div class="f18 mb20 mt20">Métodos de Pago</div>
                <table class="summary">
                    <tr>
                        <th>Método</th>
                        <th v-if="cashierTurn" class="pr5">{{mobile ? 'Pedidos' : 'Transacciones'}}</th>
                        <th v-if="cashierTurn" class="pr5">{{mobile ? 'Pagos' : 'Pagos Liquidados'}}</th>
                        <th v-if="cashierTurn" class="pr5">Gastos</th>
                        <th v-if="modalTurn.ghost_close" class="pr5">{{mobile ? 'Recuento' : 'Total Recuento'}}</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="method in modalTurn.balance"
                    :key="method.data" @click="OpenTransactionsByMethod(method.data)" class="selectable">

                        <!-- <td v-html="method.data == 'CASH' && cashierTurn ? 
                        `Efectivo <div class='secondary-text' title='Efectivo inicial'>${!modalTurn.not_add_initial_cash ? '<i class=\'\'></i>"' + Util.Price(modalTurn.initial_cash) : ''}</div>` : Util.PayMethod(method.data)" class="pr5"></td> -->
                        <td style="vertical-align: top;">{{Util.PayMethod(method.data)}}
                            <div v-if="method.data == 'CASH' && !modalTurn.not_add_initial_cash" v-tooltip="'Efectivo inicial'" class="secondary-text"><i class="icon icon-bill"></i> {{ Util.Price(modalTurn.initial_cash) }}</div>
                        </td>
                        <td v-if="cashierTurn" class="pr5 flex column flex-fill" style="vertical-align: top;">
                            {{Util.Price(method.transactions_income)}}
                            <span v-if="TipMethodDeclaration(method.data)" class="secondary-text" v-tooltip="'Propina'"><i class="icon icon-coins"></i> {{TipMethodDeclaration(method.data, true)}}</span>
                            <!-- <span v-if="TipMethodDeclaration(method.data)" class="secondary-text">+ <span v-if="desktop">propina</span> {{TipMethodDeclaration(method.data, true)}}</span> -->
                        </td>
                        <td v-if="cashierTurn" class="pr5" style="vertical-align: top;">{{Util.Price(method.pending_payments_income)}}</td>
                        <td v-if="cashierTurn" class="pr5" style="vertical-align: top;">{{Util.Price(method.total_expense)}}</td>
                        <td v-if="modalTurn.ghost_methods[method.data]" :class="'pr5 ' + (method.ghost_total < method.total ? 'cred' : (method.ghost_total !== (method.total + TipMethodDeclaration(method.data)) ? 'cyellow' : ''))">
                            {{Util.Price(method.ghost_total)}}
                            <div v-if="CalculateTotalCountGhostClose(method) !== 0" v-tooltip="'Diferencia el recuento con lo registrado'" class="secondary-text" style="color: inherit">
                            <i v-if="(method.ghost_total !== (method.total + TipMethodDeclaration(method.data)))" class="icon icon-circle-exclamation"></i>
                            {{CalculateTotalCountGhostClose(method) < 0 ? '- ' : '+ '}}{{ Util.Price(Math.abs(CalculateTotalCountGhostClose(method)))}}
                            </div>
                        </td>
                        <td v-else></td>
                        <td style="text-align: right; vertical-align: top;">{{Util.Price(TipMethodDeclaration(method.data) + method.total)}}</td>
                    </tr>


                </table>
            </div>

            <div class="" v-if="showTips || modalTurn.ended_at">

                <div class="f18 mb20 mt20">Propinas</div>
                <table class="summary">
                    <tr>
                        <th>Cuenta</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="(tip, index) in StaffTable(modalTurn.tips.staff)"
                    :key="index+'tip_staff'"
                    class="selectable"
                    @click="$refs.transactionsList.Open(tip.transactions)">
                        <td :style="!tip.transactions.length ? {'padding-left': '15px'} : {}" v-html="tip.data.replace('> ', `<span class='secondary-text'>> </span>`)"></td>
                        <!-- <td :style="!tip.transactions.length ? {'padding-left': '15px'} : {}">{{tip.data}}</td> -->
                        <td style="text-align: right">{{Util.Price(tip.total)}}</td>
                    </tr>
                    <tr>
                        <td class="bold">Total Propinas</td>
                        <td style="text-align: right">{{Util.Price(modalTurn.tips.total)}}</td>
                    </tr>
                </table>
            </div>

            <div class="" v-if="modalTurn.delivery && (showDelivery || modalTurn.ended_at)">
                
                <div class="f18 mb20 mt20">Reparto</div>
                <table class="summary">
                    <tr>
                        <th>Cuenta</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="(entry, index) in StaffTable(modalTurn.delivery.internal.staff)"
                    :key="index+'delivery internal'"
                    class="selectable"
                    @click="$refs.transactionsList.Open(entry.transactions)">
                        <td :style="!entry.transactions.length ? {'padding-left': '15px'} : {}">{{entry.data}}</td>
                        <td style="text-align: right">{{Util.Price(entry.total)}}</td>
                    </tr>
                    <tr>
                        <td class="bold">Total Reparto</td>
                        <td style="text-align: right">{{Util.Price(modalTurn.delivery.internal.total)}}</td>
                    </tr>
                </table>
            </div>

            <div class="" v-if="modalTurn.delivery && (showDelivery || modalTurn.ended_at)">

                <div class="f18 mb20 mt20">Reparto Externo</div>
                <table class="summary">
                    <tr>
                        <th>Cuenta</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="(entry, index) in StaffTable(modalTurn.delivery.external.staff)"
                    :key="index+'delivery external'"
                    class="selectable"
                    @click="$refs.transactionsList.Open(entry.transactions)">
                        <td :style="!entry.transactions.length ? {'padding-left': '15px'} : {}">{{entry.data}}</td>
                        <td style="text-align: right">{{Util.Price(entry.total)}}</td>
                    </tr>
                    <tr>
                        <td class="bold">Total Reparto Externo</td>
                        <td style="text-align: right">{{Util.Price(modalTurn.delivery.external.total)}}</td>
                    </tr>
                </table>
            </div>

            <div class="" v-if="modalTurn.expenses && (showExpenses || modalTurn.ended_at) && modalTurn.role !== 'delivery'">

                <div class="f18 mb20 mt20">Gastos</div>
                <table class="summary">
                    <tr>
                        <th>Gasto</th>
                        <th>Fecha</th>
                        <th>Método</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="(expense, index) in modalTurn.expenses"
                    :key="index"
                    class="selectable"
                    @click="expense.type == 'expense' ? $refs.expenseDetails.Open(expense.id) : $refs.inventoryDetails.Open(expense.id)">
                        <td>{{expense.data}}</td>
                        <td>{{Util.Date(expense.created_at, 'HH:mm DD/MM/YY')}}</td>
                        <td>{{Util.PayMethod(expense.method)}}</td>
                        <td style="text-align: right">{{Util.Price(expense.total_money)}}</td>
                    </tr>
                </table>
            </div>

            <div class="" v-if="Local.modules.module_margin">
                <div class="f18 mb20 mt20">Margen de Contribución</div>
                <table class="summary mt10">
                    <tr>
                        <th>Ítem</th>
                        <th>Cantidad</th>
                        <th class="pr5">{{mobile ? 'Ventas B.' : 'Ventas brutas'}}</th>
                        <th class="pr5">{{mobile ? 'Ventas N.' : 'Ventas netas'}}</th>
                        <th class="pr5">{{mobile ? 'Costos N.' : 'Costos netos'}}</th>
                        <th class="pr5">{{mobile ? 'Costos N. (%)' : 'Costos netos (%)'}}</th>
                        <th class="pr5">{{mobile ? 'Margen' : 'Margen de contribución'}}</th>
                    </tr>
                    <tbody v-for="(item, index) in modalTurn.items_net_costs" :key="index">
                        <tr class="selectable">
                            <td>{{item.title}}</td>
                            <td>{{item.quantity}}</td>
                            <td>{{Util.Price(item.total_money)}}</td>
                            <td>{{Util.Price(item.total_money / 1.19)}}</td>
                            <td>{{Util.Price(item.net_cost)}}</td>
                            <td>
                                {{ ((Math.floor((item.net_cost * 1000) / (item.total_money / 1.19)) / 10) || 0) }}%
                            </td>
                            <td>{{Util.Price(ContributionMargin(item))}} ({{ContributionMargin(item, true)}}%)</td>
                        </tr>
                        <tr
                            v-for="(modifier, modKey) in item.modifiers"
                            :key="index + '-' + modKey"
                            class="selectable"
                            style="color: #555;"
                        >
                            <td style="padding-left:15px">{{ modifier.title }}</td>
                            <td>{{ Util.Number(modifier.count) }}</td>
                            <td>{{ item.combo? '-' : Util.Price(modifier.total_money || 0) }}</td>
                            <td>{{ item.combo? '-' : Util.Price(modifier.total_money / 1.19 || 0) }}</td>
                            <td>{{ item.combo? '-' : Util.Price(modifier.net_cost || 0) }}</td>
                            <td>
                                {{ item.combo? '-' : ((Math.floor((modifier.net_cost * 1000) / (modifier.total_money / 1.19)) / 10) || 0) + '%' }}
                            </td>
                            <td>{{ item.combo? '-' : Util.Price(ContributionMargin(modifier)) }} <span v-if="!item.combo">({{ ContributionMargin(modifier, true) }}%)</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="" v-if="(showPendingPayments || modalTurn.ended_at) && modalTurn.role !== 'delivery'">

                <div class="f18 mb20 mt20">Pagos Pendientes Liquidados</div>
                <table class="summary">
                    <tr>
                        <th>Pago</th>
                        <th>Fecha</th>
                        <th>Método</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="(pp, index) in modalTurn.pending_payments"
                    :key="index"
                    class="selectable"
                    @click="$refs.pendingPaymentDetails.Open(pp.id)">
                        <td>{{pp.data}}</td>
                        <td>{{Util.Date(pp.created_at, 'HH:mm DD/MM/YY')}}</td>
                        <td>{{Util.PayMethod(pp.method)}}</td>
                        <td style="text-align: right">{{Util.Price(pp.total_money)}}</td>
                    </tr>
                </table>
            </div>
            <div class="" v-if="modalTurn.invoices && (showInvoices || modalTurn.ended_at) && modalTurn.role !== 'delivery'">

                <div class="f18 mb20 mt20">Documentos de Proveedores Liquidados</div>
                <table class="summary">
                    <tr>
                        <th>Documento</th>
                        <th>Fecha</th>
                        <th>Método</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="(invoice, index) in modalTurn.invoices"
                    :key="index"
                    class="selectable"
                    @click="$refs.invoiceDetails.Open(invoice.id, false, 'turn')">
                        <td>{{invoice.data}}</td>
                        <td>{{Util.Date(invoice.created_at, 'HH:mm DD/MM/YY')}}</td>
                        <td>{{Util.PayMethod(invoice.method)}}</td>
                        <td style="text-align: right">{{Util.Price(invoice.total_money)}}</td>
                    </tr>
                </table>
            </div>

            <div class="" v-if="modalTurn.items && (showItems || modalTurn.ended_at) && modalTurn.role !== 'delivery'">

                <div class="f18 mb20 mt20">Items</div>
                <table class="summary">
                    <tr>
                        <th>Item</th>
                        <th>Cantidad</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="(item, index) in modalTurn.items"
                    :class="item.transactions ? 'selectable' : ''"
                    @click="item.transactions ? $refs.transactionsList.Open(item.transactions) : null"
                    :key="index">
                        <td :style="{'padding-left': item.total === null ? '15px' : ''}">{{item.title}}</td>
                        <td>{{Util.Number(item.quantity)}}</td>
                        <td style="text-align: right">{{item.total !== null ? Util.Price(item.total) : ''}}</td>
                    </tr>
                </table>
            </div>
            <div class="" v-if="modalTurn.inventory && (showInventory || modalTurn.ended_at) && modalTurn.role !== 'delivery'">
                
                <div class="f18 mb20 mt20">Inventario</div>
                <table class="summary">
                    <tr>
                        <th>Item</th>
                        <th>Agregado</th>
                        <th>Utilizado</th>
                        <th style="text-align: right">Final</th>
                    </tr>
                    <tr v-for="(item, index) in modalTurn.inventory.used"
                    :key="index">
                        <td>{{item.title}}</td>
                        <td :class="item.added > 0 ? 'cgreen' : ''">{{Util.Number(item.added, false, true)}} <span v-if="item.added_turn">({{Util.Number(item.added_turn)}})</span> <span v-if="item.unit" class="secondary-text">{{item.unit}}</span></td>
                        <td :class="item.used > 0 ? 'cred' : ''">-{{Util.Number(item.used)}} <span v-if="item.used_turn && item.used_turn !== item.used">({{Util.Number(item.used_turn)}})</span> <span v-if="item.unit" class="secondary-text">{{item.unit}}</span><span class="secondary-text" v-if="!(item.used === 0 || item.unit_cost === 0)" v-tooltip="`Valorizado con costo unitario ${Util.Price(item.unit_cost)}`">{{` (${Util.Price(item.used * item.unit_cost)})` }}</span></td>
                        <td style="text-align: right" :class="parseFloat(item.to) > parseFloat(item.from) ? 'cgreen' : 'cred'">{{Util.Number(item.from)}} <span v-if="item.unit" class="secondary-text">{{item.unit}}</span> <i class="icon icon-arrow-right secondary-text"></i> {{Util.Number(item.to)}} <span v-if="item.unit" class="secondary-text">{{item.unit}}</span></td>
                    </tr>
                </table>

                <div class="f18 mb20 mt20">Movimientos de Inventario</div>

                <table class="summary">
                    <tr style="text-align: right">
                        <th>Item</th>
                        <th>Cantidad</th>
                        <th>Total</th>
                        <th>Método</th>
                        <th style="text-align: right">Fecha</th>
                    </tr>
                    <tr v-for="(item, index) in modalTurn.inventory.transactions"
                    :key="index"
                    class="selectable"
                    @click="$refs.inventoryDetails.Open(item.id)">
                        <td>{{item.title}}</td>
                        <!-- TODO: falta la unidad de medida aqui -->
                        <td :class="item.quantity < 0 ? 'cred' : 'cgreen'">{{`${Util.Number(item.quantity, false, true)}`}} <span v-if="!(item.used === 0 || item.unit_cost === 0)" class="secondary-text" v-tooltip="`Valorizado con costo unitario ${Util.Price(item.unit_cost)}`">{{  (`${Util.Price(item.quantity < 0 ? (item.quantity * -1) * item.unit_cost : item.quantity * item.unit_cost)}`) }}</span></td>
                        <td>{{Util.Price(item.total_money)}}</td>
                        <td>{{Util.PayMethod(item.method)}}</td>
                        <td style="text-align: right">{{Util.Date(item.created_at, 'HH:mm DD/MM/YY')}}</td>
                    </tr>
                </table>

            </div>
        </div>
        
        <div slot="Transacciones" v-if="modalTurn && oldView" class="pa20 copyable">
            <div class="" v-if="(showTransactions || modalTurn.ended_at)">

                <div class="f18 mb20">Transacciones</div>
                <table class="summary">
                    <tr>
                        <th>Número</th>
                        <th>Ingresada</th>
                        <th>Completada</th>
                        <th>Cancelada</th>
                        <th v-show="!mobile">Método de pago</th>
                        <th style="text-align: right">Total</th>
                    </tr>
                    <tr v-for="transaction in modalTurn.transactions"
                    :key="transaction.id"
                    class="selectable"
                    @click="$refs.transactionDetails.Open(transaction.id)">
                        <td> <span v-html="TicketType(transaction)"></span> {{transaction.number.replace(/#0*/g, '#')}} <span v-if="transaction.table_name" class="secondary-text">({{transaction.table_name}})</span></td>
                        <td><span v-if="transaction.created_at" :class="transaction.created_at == transaction.paid_at ? `cgreen` : ''" :title="Util.Date(transaction.created_at, 'HH:mm DD/MM/YY')">{{Util.Date(transaction.created_at, 'HH:mm')}}</span></td>
                        <td><span v-if="transaction.completed_at" :class="transaction.completed_at == transaction.paid_at ? `cgreen` : ''" :title="Util.Date(transaction.completed_at, 'HH:mm DD/MM/YY')">{{Util.Date(transaction.completed_at, 'HH:mm')}}</span></td>
                        <td><span v-if="transaction.cancelled_at" :title="Util.Date(transaction.cancelled_at, 'HH:mm DD/MM/YY')">{{Util.Date(transaction.cancelled_at, 'HH:mm')}}</span></td>
                        <td v-show="!mobile"><span :title="transaction.payment_methods.length > 1 ? transaction.payment_methods.map(p => Util.PayMethod(p.method)).join(', ') : null">{{ Util.PayMethod(transaction.payment_methods[0].method)}} <template v-if="transaction.payment_methods.length > 1"> ...</template></span></td>
                        <td style="text-align: right"><i v-if="transaction.pending_payment" title="Pago pendiente" class="icon icon-hourglass cyellow"></i> {{Util.Price(transaction.total_money)}}</td>
                    </tr>
                    <tr>
                        <td class="bold">Total</td>
                        <td>{{Util.Number(modalTurn.transactions_count.created)}}</td>
                        <td>{{Util.Number(modalTurn.transactions_count.completed)}}</td>
                        <td>{{Util.Number(modalTurn.transactions_count.cancelled)}}</td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
            </div>

            <div class="" v-if="(showEdit || modalTurn.ended_at) && modalTurn.role !== 'delivery'">

                <div class="f18 mb20 mt20">Transacciones Editadas</div>
                 <table class="summary">
                    <tr>
                        <th>Número</th>
                        <th>Editada</th>
                        <th>Comentario</th>
                    </tr>
                    <tr v-for="(revision, index) in modalTurn.edit"
                    :key="index"
                    class="selectable"
                    @click="$refs.transactionDetails.Open(revision.id)">
                        <td>{{revision.id_ticket.replace(/#0*/g, '#')}}</td>
                        <td>{{Util.Date(revision.created_at, 'HH:mm DD/MM/YYYY')}}</td>
                        <td>{{revision.comment}}</td>
                    </tr>
                </table>
            </div>
        </div>

        <vertical-content slot="Historial" @OnBottom="LoadTurnHistory()" class="pa20">
            <history-log :entries="modalTurn.history" cssClass="entry"></history-log>
        </vertical-content>
    </tabs>

    <transaction-details ref="transactionDetails" @OnTransactionDeleted="Open(modalTurn.id)"></transaction-details>
    <transactions-list ref="transactionsList" @OnTransactionDeleted="Open(modalTurn.id)"></transactions-list>
    <expense-details ref="expenseDetails" @OnTransactionDeleted="Open(modalTurn.id)"></expense-details>
    <inventory-details ref="inventoryDetails" @OnTransactionDeleted="Open(modalTurn.id)"></inventory-details>
    <pending-payment-details ref="pendingPaymentDetails"></pending-payment-details>
    <invoice-details ref="invoiceDetails" @OnLoadTurn="LoadTurn(modalTurn.id)"></invoice-details>

</modal>
</template>
<script>
export default {
    props: {
        showSummary: {
            type: Boolean,
            default: true
        },
        showComments: {
            type: Boolean,
            default: true
        },
        showMethods: {
            type: Boolean,
            default: true
        },
        showTransactions: {
            type: Boolean,
            default: true
        },
        showEdit: {
            type: Boolean,
            default: true
        },
        showDelivery: {
            type: Boolean,
            default: true
        },
        showTips: {
            type: Boolean,
            default: true
        },
        showPendingPayments: {
            type: Boolean,
            default: true
        },
        showInvoices: {
            type: Boolean,
            default: true
        },
        showExpenses: {
            type: Boolean,
            default: true
        },
        showItems: {
            type: Boolean,
            default: true
        },
        showInventory: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            modalTurn: null,
            tabs: null,
            oldView: true
        }
    },
    mounted() {
        this.tabs = [];
        this.tabs.push('Resumen', 'Transacciones');
        if(this.Auth.role.indexOf('admin') > -1) this.tabs.push('Historial');
        // this.tabs.push('Transacciones');
    },
    methods: {
        Open(id) {
            this.$root.$on('PendingPaymentPaid', this.OnPendingPaymentPaid);
            if(typeof id == 'number')
            {
                this.LoadTurn(id);
            }
            else
            {
                id.history = [];
                this.modalTurn = id;
            }
        },
        LoadTurn(id) {
            this.Loading();
            axios.get(`/turn/${id}`).then(res => {
                this.Response(res);
                res.data.history = [];
                this.modalTurn = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadTurnHistory() {
            this.Loading();
            axios.get(`/turn/${this.modalTurn.id}/history${this.modalTurn.history.length?'/'+this.modalTurn.history[this.modalTurn.history.length-1].id:''}`).then(res => {
                this.Response(res);
                this.modalTurn.history = this.modalTurn.history.concat(res.data);
            }).catch(err => {
                this.Response(err);
            });
        },
        Export()
        {
            this.Loading();
            axios.get(`/turn/${this.modalTurn.id}/export`, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            }).then(res => {
                    this.Response(res);
                    this.Util.DownloadFile(res, `turno_${this.modalTurn.name.toLowerCase()}_${this.Util.Date(this.modalTurn.started_at, 'DD-MM-YYYY')}.pdf`);
            }).catch(err => {
                this.Response(err);
            });
        },
        Print()
        {
            var moment = require('moment');
            var arr = [];
            let differences = {};
            arr.push({text: this.Local.name, align: 'CT', width: 2, height: 2});
            arr.push({text: `Turno de ${this.modalTurn.name}`});
            arr.push({text: `Inicio: ${moment.unix(this.modalTurn.started_at).format('HH:mm DD/MM/YYYY')}`});
            if(this.modalTurn.ended_at) arr.push({text: `Fin: ${this.modalTurn.ended_at ? moment.unix(this.modalTurn.ended_at).format('HH:mm DD/MM/YYYY') : 'Activo'}`});
            if(this.cashierTurn) 
            {
                arr.push({text: ['Efectivo inicial', this.Util.Number(this.modalTurn.initial_cash)]});
                arr.push({line: true});
                arr.push({text: ['Total ingresos', this.Util.Number(this.modalTurn.total_income)]});
                arr.push({text: ['Total egresos', this.Util.Number(this.modalTurn.total_expense)]});
                if(this.modalTurn.current_pending_payments.total > 0) 
                    arr.push({text: ['Total pendiente', this.Util.Number(this.modalTurn.current_pending_payments.total)]});
            }
            
            arr.push({line: true});
            arr.push({text: 'Transacciones'});
            arr.push({text: ['> Ingresadas', this.Util.Number(this.modalTurn.transactions_count.created)]});
            arr.push({text: ['> Completadas', this.Util.Number(this.modalTurn.transactions_count.completed)]});
            arr.push({text: ['> Canceladas', this.Util.Number(this.modalTurn.transactions_count.cancelled)]});

            arr.push({line: true});
            arr.push({text: 'RESUMEN CUADRATURA CAJA'});
            arr.push({line: true});
            arr.push({text: 'Por plataforma'});
            for(var i = 0; i < this.modalTurn.balance.length; i++)
            {
                var method = this.modalTurn.balance[i];
                var total = (method.data == 'CASH' ? (!this.modalTurn.not_add_initial_cash ? this.modalTurn.initial_cash : 0 ): 0) + method.pending_payments_income + method.transactions_income - method.total_expense;
                // var ingresos = method.transactions_income + method.pending_payments_income;
                // if (method.data == 'CASH' && !this.modalTurn.not_add_initial_cash) {
                //     ingresos += this.modalTurn.initial_cash; 
                // }

                let tip = this.MethodsTips(method.data);
                arr.push({text: [`> ${this.Util.PayMethod(method.data)}`, this.Util.Number(total)]});
                arr.push({ text: ['  + Propina', this.Util.Number(tip)] });
                differences[method.data] = total;    
            }

            if(this.modalTurn.ghost_close) {
                arr.push({line: true});
                arr.push({text: 'Recuento declarado por el cajero'});
                let ghost = {};
                Object.keys(this.modalTurn.ghost_methods).forEach(methods => {
                    let findMethod = this.modalTurn.balance.find(m => m.data == methods);
                    if(findMethod)
                    {
                        let tip = this.MethodsTips(findMethod.data);
                        let payMethod = this.Util.PayMethod(methods);
                        ghost[findMethod.data] = findMethod.ghost_total;
                        differences[findMethod.data] -= findMethod.ghost_total;
                        arr.push({text: ['> ' + payMethod + `${this.modalTurn.tip_declarations[payMethod] ? ' (c/ propina)' : ''}`, this.Util.Number(findMethod.ghost_total)]});
                        arr.push({ text: ['  + Propina', this.Util.Number(tip)] });
                    }
                });

                arr.push({line: true});
                arr.push({text: 'Diferencias'});
                let totalDifferences = 0;
                Object.keys(differences).forEach(method => {
                    if(differences[method] !== 0) {
                        if(method == 'CASH' && !ghost['CASH']) differences[method] =  this.modalTurn.initial_cash - differences[method];

                        arr.push({text: ['> ' + this.Util.PayMethod(method), (differences[method] > 0 ? '- ' : '+ ') + this.Util.Number(Math.abs(differences[method]))]});
                    }
                    totalDifferences += differences[method];
                });
                arr.push({text: ['Total diferencias',(totalDifferences > 0 ? '- ' : '+ ') + this.Util.Number(Math.abs(totalDifferences))]});
            }

            if(this.modalTurn.delivery)
            {
                if(this.modalTurn.delivery.internal.total)
                {
                    arr.push({line: true});
                    arr.push({text: ['Total reparto interno', this.Util.Number(this.modalTurn.delivery.internal.total)]});
                    this.modalTurn.delivery.internal.staff.forEach(delivery => {
                        arr.push({text: [`> ${delivery.account}`, this.Util.Number(delivery.total)]})
                    });
                }
                if(this.modalTurn.delivery.external.total)
                {
                    arr.push({line: true});
                    arr.push({text: ['Total reparto externo', this.Util.Number(this.modalTurn.delivery.external.total)]});
                    this.modalTurn.delivery.external.staff.forEach(delivery => {
                        arr.push({text: [`> ${delivery.account}`, this.Util.Number(delivery.total)]})
                    });
                }
            }

            if(this.modalTurn.tips)
            {
                if(this.cashierTurn)
                {
                    arr.push({line: true});
                    arr.push({text: ['Total propinas', this.Util.Number(this.modalTurn.tips.total)]});
                    this.modalTurn.tips.staff.forEach(tip => {
                        arr.push({text: [`> ${tip.account}`, this.Util.Number(tip.total)]})
                    });
                }
                else
                {
                    this.modalTurn.tips.staff.forEach(tip => {
                        if(tip.account == this.modalTurn.name)
                        {
                            arr.push({line: true});
                            arr.push({text: ['Total propinas', this.Util.Number(tip.total)]});
                            for(var key in tip.methods)
                            {
                                arr.push({text: [`> ${this.Util.PayMethod(key)}`, this.Util.Number(tip.methods[key].total)]})
                            }
                        }
                    });
                }
            }

            if(this.modalTurn.comments && this.modalTurn.comments.length)
            {
                arr.push({line: true});
                this.modalTurn.comments.forEach(comment => {
                    arr.push({text: `${this.Util.Date(comment.timestamp, 'HH:mm DD/MM/YYYY')} - ${comment.message}`});
                });
            }            

            this.Util.NotifyService('print', {data: arr, id: Math.random().toString()});

        },
        PrintInventory()
        {
            var moment = require('moment');
            var arr = [];
            arr.push({text: this.Local.name, align: 'CT', width: 2, height: 2});
            arr.push({text: `Turno de ${this.modalTurn.name}`});
            arr.push({text: `Inicio: ${moment.unix(this.modalTurn.started_at).format('HH:mm DD/MM/YYYY')}`});
            arr.push({text: `Fin: ${this.modalTurn.ended_at ? moment.unix(this.modalTurn.ended_at).format('HH:mm DD/MM/YYYY') : 'Activo'}`});
            arr.push({line: true});
            arr.push({text: 'Inventario'});

            let groupedInventory = this.modalTurn.inventory.used.reduce((result, item) => {
                if (!result[item.section]) result[item.section] = [];
                result[item.section].push(item);
                return result;
            }, {});

            Object.entries(groupedInventory).forEach(([section, inventories]) => {
                arr.push({ text:'-- ' + section + ' --' });
                inventories.forEach(inventory => {
                    let unit = inventory.unit ? ` ${inventory.unit}` : '';
                    arr.push({text: [inventory.title, `${this.Util.Number(inventory.from) + unit} > ${this.Util.Number(inventory.to) + unit}`]});
                    arr.push({text: '- Agregado: ' + this.Util.Number(inventory.added) + unit});
                    arr.push({text: '- Utilizado: ' + this.Util.Number(inventory.used) + unit});
                });
                arr.push({text: ''});
            });

            this.Util.NotifyService('print', {data: arr, id: Math.random().toString()});

        },
        StaffTable(table)
        {
            var ret = [];

            table.forEach(entry => {
                ret.push({data: entry.account, total: entry.total, transactions: entry.id_transactions});
                for(var key in entry.methods)
                {
                    ret.push({data: ` > ${this.Util.PayMethod(entry.methods[key].method)}`, total: entry.methods[key].total, transactions: entry.methods[key].id_transactions});
                }
            });
            
            return ret;
        },
        TicketType(ticket)
        {
            if(ticket.type == 'DELIVERY') return '<i class="icon icon-delivery" style="color : var(--color-delivery-transit);"></i>';
            if(ticket.type == 'TAKEAWAY') return '<i class="icon icon-bag"  style="color: var(--color-takeaway);"></i>';
            if(ticket.type == 'SERVE' && !ticket.table_name) return '<i class="icon icon-serve" style="color: var(--color-serve);"></i>';
            if(ticket.type == 'SERVE' && ticket.table_name) return '<i class="icon icon-table" style="color: var(--color-table);"></i>';
        },
        ContributionMargin(item, percent = false){
            let netSales = item.total_money / 1.19;
            let contributionMargin = netSales - item.net_cost;
            if(!percent) return contributionMargin;

            let contributionMarginPercent = (contributionMargin / netSales) * 100;
            return Math.floor(contributionMarginPercent * 10) / 10;
        },
        OpenTransactionsByMethod(method){
            if(!this.modalTurn || !this.$refs.transactionsList) return;
            console.log(this.modalTurn.methods_transactions);
            let transactions = this.modalTurn.methods_transactions[method];
            if(method == 'Transferencia')
            {
                let bankDepositTransactions = this.modalTurn.methods_transactions['BANK_DEPOSIT'];
                if(bankDepositTransactions) 
                {
                    transactions = (transactions ? transactions : []).concat(bankDepositTransactions);
                    transactions.sort((a, b) => b - a);
                }
            } 
            if(!transactions) return;
            this.$refs.transactionsList.Open(transactions);

        },
        CalculateTotalCountGhostClose(method) {
            return Number(method.ghost_total) - (Number(method.pending_payments_income) + Number(method.transactions_income) + (method.data === 'CASH' && !this.modalTurn.not_add_initial_cash ? Number(this.modalTurn.initial_cash || 0) : 0) - method.total_expense+ this.TipMethodDeclaration(method.data))
        },
        TipMethodDeclaration(method, currency = false) {
            if(!this.modalTurn) return 0;
            if(!this.modalTurn.ghost_close) return 0;
            if(method == 'Transferencia') method = 'BANK_DEPOSIT';
            if(!this.modalTurn.tip_declarations) return 0;
            let declaration = this.modalTurn.tip_declarations[method];
            if(!declaration) return 0;
            let tip = this.modalTurn.tips.methods.find(tip => tip.method == method);
            if(!tip) return 0;
            if(tip.total == 0) return 0;
            return currency ? this.Util.Price(tip.total) : Math.round(tip.total);
        },
        MethodsTips(method){
            if(!this.modalTurn) return 0;
            if(method == 'Transferencia') method = 'BANK_DEPOSIT';
            let tip = this.modalTurn.tips.methods.find(tip => tip.method == method);
            if(!tip) return 0;
            if(tip.total == 0) return 0;
            return Math.round(tip.total);
        },
        OnPendingPaymentPaid(){
            if(!this.Turn || !this.modalTurn) return;
            if(this.$refs.transactionDetails) this.$refs.transactionDetails.Close();
            this.LoadTurn(this.Turn.id);
        }
    },
    computed: {
        cashierTurn() {
            if(!this.modalTurn) return false;
            return ['waiter', 'delivery'].indexOf(this.modalTurn.role) == -1;
        }
    },
    beforeDestroy() {
        this.$root.$off('PendingPaymentPaid', this.OnPendingPaymentPaid);
    },
}
</script>
<style lang="scss">
//Mobile
@media (max-width: 820px) {
    .icon-small-mobile {
        position: relative;
        .avatar {
            background: transparent !important;
            position: absolute;
            left: 2px;
            top: 3px;
            transform: scale(0.7);
        }
    }
}
</style>